/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can I reduce fatigue during a 5-minute typing test?`)
};

const es_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo puedo reducir la fatiga durante un test de mecanografía de 5 minutos?`)
};

const de_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie kann ich Ermüdung während eines 5-Minuten-Tipptests reduzieren?`)
};

const nl_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe kan ik vermoeidheid tijdens een typetest van 5 minuten verminderen?`)
};

const fr_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment puis-je réduire la fatigue pendant un test de frappe de 5 minutes ?`)
};

const it_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come posso ridurre la stanchezza durante un test di digitazione da 5 minuti?`)
};

const pt_br2_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como posso reduzir o cansaço durante um teste de digitação de 5 minutos?`)
};

const pt_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como posso reduzir o cansaço durante um teste de escrita de 5 minutos?`)
};

const ja_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5分間のタイピングテスト中の疲労を減らすには？`)
};

const zh_typing_u5_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何在5分钟打字测试中减少疲劳？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u5_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u5_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u5_faq4_q", locale)
	if (locale === "en") return en_typing_u5_faq4_q(inputs)
	if (locale === "es") return es_typing_u5_faq4_q(inputs)
	if (locale === "de") return de_typing_u5_faq4_q(inputs)
	if (locale === "nl") return nl_typing_u5_faq4_q(inputs)
	if (locale === "fr") return fr_typing_u5_faq4_q(inputs)
	if (locale === "it") return it_typing_u5_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u5_faq4_q(inputs)
	if (locale === "pt") return pt_typing_u5_faq4_q(inputs)
	if (locale === "ja") return ja_typing_u5_faq4_q(inputs)
	return zh_typing_u5_faq4_q(inputs)
};